module.exports = __webpack_public_path__ + "static/media/revenueActive.0015228a.svg";